import { ApiService } from '../../constants';
import { HttpService } from '../../utilities';

interface GetNotification {}

interface GetTodoList {}

export const getNotification = ({}: GetNotification) => {
  return HttpService.get(`${ApiService.icdc.module.notif.getNotif}`);
};

export const getTodoList = ({}: GetTodoList) => {
  return HttpService.get(`${ApiService.beelajar.getTodoList}`);
};

export const postNotifClicked = (data) => {
  return HttpService.post(ApiService.icdc.module.notif.addClicked, data);
};

export const seeAll = (data) => {
  return HttpService.post(ApiService.icdc.module.notif.seeAll, data);
};
